import script from "./metaInfo.vue?vue&type=script&lang=js"
export * from "./metaInfo.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__